import { render, staticRenderFns } from "./ThankYouQuickRegister.vue?vue&type=template&id=1e364aff&scoped=true&"
import script from "./ThankYouQuickRegister.vue?vue&type=script&lang=ts&"
export * from "./ThankYouQuickRegister.vue?vue&type=script&lang=ts&"
import style0 from "./ThankYouQuickRegister.vue?vue&type=style&index=0&id=1e364aff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e364aff",
  null
  
)

export default component.exports